module.exports = __webpack_public_path__ + "static/img/kf_cloud_00009.b80af52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00009.jpg
// module id = 180
// module chunks = 1